.Topbar {
  display: flex;
  padding: 8px 32px;
  width: 100%;
  align-items: center;
  background: var(--primary);
  height: var(--topbar-desktop-height);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  align-items: center;
  justify-content: space-between;
}

.TopbarDebug {
  background: var(--secondary);
}

.WikiLoveMonuments {
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: var(--colori-neutri-white);
  text-align: center;
  /* H2 */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  cursor: pointer;
  line-height: normal;
}

.ButtonConcorso {
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  border: 2px solid var(--concorso);
  background: var(--colori-neutri-white);
  color: var(--primary);
  text-align: center;
  /* H2 */
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.Burger {
  padding: 2px;
  cursor: pointer;
}

.Legend {
  padding: 2px;
  cursor: pointer;
}

.BurgerOpen {
  border-radius: 5px;
  padding: 1px;
  border: 1px solid var(--colori-neutri-white);
  /* Markers */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  /* padding: 2px; */
}

.LegendOpen {
  border-radius: 5px;
  padding: 1px;
  border: 1px solid var(--colori-neutri-white);
  /* Markers */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  /* padding: 2px; */
}

.Login {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  color: var(--colori-neutri-white);
  text-decoration: none;
  margin-right: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.LinkScraping {
  border-radius: 5px;
  background: var(--Monumenti-Senza-foto, #cf4130);
  display: flex;
  padding: 4px 8px;
  align-items: center;
  color: var(--colori-neutri-white);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-right: 20px;
  font-family: var(--font-roboto-slab);
}

.LinkScrapingOsm {
  border-radius: 5px;
  /* change color violetto non #cf4130 */
  background: #a22690;
  display: flex;
  padding: 4px 8px;
  align-items: center;
  color: var(--colori-neutri-white);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-right: 20px;
  font-family: var(--font-roboto-slab);
}

.LinkScrapingCommons {
  border-radius: 5px;
  /* change color violetto non #cf4130 */
  background: #a22690;
  display: flex;
  padding: 4px 8px;
  align-items: center;
  color: var(--colori-neutri-white);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-right: 20px;
  font-family: var(--font-roboto-slab);
}

.LinkScrapingOsm:hover {
  background: #a22690;
  opacity: 0.8;
  cursor: pointer;
}

.LinkScraping:hover {
  background: var(--Monumenti-Senza-foto-hover, #cf4130);
  opacity: 0.8;
  cursor: pointer;
}

.LinkScrapingCommons:hover {
  background: #a22690;
  opacity: 0.8;
  cursor: pointer;
}

.ResponseOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.2);
  padding: 24px 16px;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.TextBeforeLogin {
  color: var(--primary);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.License {
  display: flex;
  align-items: center;
  color: var(--colori-neutri-dark-gray);
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.ResponseContainer {
  display: flex;
  width: 40%;
  height: 592px;
  padding: 16px 64px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 71px;
  flex-shrink: 0;
  border-radius: 5px;
  background: var(--overlay);
}

.ButtonAccetta {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  align-self: stretch;
  border-radius: 5px;
  background: var(--concorso);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--concorso-shadow);
  border: none;
  color: var(--colori-neutri-white, #fff);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
